export const COMP_OP_LE = "LE";
export const LOGIC_OP_AND = "AND";
export const LOGIC_OP_OR = "OR";
export const COMP_OP_EQ = "EQ";
export const COMP_OP_GE = "GE";

export const COMP_OP_GT = "GT";
